var map = {
	"./aed.png": 896,
	"./aud.png": 897,
	"./bgn.png": 898,
	"./bhd.png": 899,
	"./cad.png": 900,
	"./chf.png": 901,
	"./cnh.png": 902,
	"./cny.png": 903,
	"./czk.png": 904,
	"./dkk.png": 905,
	"./eur.png": 906,
	"./gbp.png": 907,
	"./hkd.png": 908,
	"./hrk.png": 909,
	"./huf.png": 910,
	"./idr.png": 911,
	"./ils.png": 912,
	"./inr.png": 913,
	"./jpy.png": 914,
	"./kes.png": 915,
	"./kwd.png": 916,
	"./mxn.png": 917,
	"./myr.png": 918,
	"./nok.png": 919,
	"./nzd.png": 920,
	"./omr.png": 921,
	"./php.png": 922,
	"./pln.png": 923,
	"./qar.png": 924,
	"./ron.png": 925,
	"./rub.png": 926,
	"./sar.png": 927,
	"./sek.png": 928,
	"./sgd.png": 929,
	"./thb.png": 930,
	"./try.png": 931,
	"./ugx.png": 932,
	"./usd.png": 933,
	"./zar.png": 934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;